import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobileText: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiText_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiTextRole',
      bindings: [
        {
          title: 'mobui_MobuiText_dataBinding_text_label',
          prop: 'text',
          supportedFieldTypes: [FieldType.text, FieldType.email],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
